/*
 * ダイアログフレームコンポーネント
 * 共通部品
 */
<template>
	<!-- use the modal component, pass in the prop -->
	<div>  
		<div v-if="r_is_first" class="modal-mask" >
		</div>
		<div :class="{'modal-mask':!r_is_first}">
			<div class="modal-mask-content" 
				:class="modal_mask_content_number" >
				<div class="modal-wrapper">
					<div class="modal-container more-detail"
						:class="container_class"
							:id="m_dragID">
						<div class="modal-header">
							<span class="image-title"></span>
							<div class="modal-title">
								<div class="title-area">
									<span class="title">{{r_title}} </span>
									<span v-for="sub in arr_sub_title"class="subtitle">
										<font class="text-accent1">{{sub}}</font>
									</span>
								</div>
							</div>
							<!-- slot="subtitle" -->
							<div class="sub-title">
								<slot name="subtitle"></slot>
							</div>
							<div class="close-btn">
								<!-- <button type="button"
									if="r_enable_cancel"
									class="btn-close fa fa-times"
									@click="onBtnCancel"></button> -->
								<button type="button"
									if="r_enable_cancel"
									class="btn-close"
									@click="onBtnCancel">
									<i class="fa-solid fa-xmark"></i>
								</button>
							</div>
						</div><!-- /.modal-header -->
						<div class="scroll-container">
							<div class="body-container" tabIndex="-1">
<!-- slot="content" -->
								<slot name="content"></slot>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
/*
<c-dlgframe
	:r_title="タイトル"
	:r_dragid="mydragid"
	:r_enable_cancel="true"
	@event_cancel="onDlgCancel">
	<div slot="subtitle"></div>
	<div slot="content"></div>
</c-dlgframe>
*/
/**
 * props 引数
 **/
export default {
	props: {
		//! タイトル文字列
		r_title: "",
		//! サブタイトル文字列
		r_subtitle:"",
		//! ドラッグID
		r_dragid: {	default: "drag"	},
		//! キャンセル有効フラグ
		r_enable_cancel: {	default: true },
		//! 第一階層モーダルフラグ
		r_is_first: false,
	},
	mixins: [
		// ドラック管理用mixin
		require('js/common/DragItem.mixin.vue'),
		// マネージャーインスタンスアクセス
		require('js/common/vuex/manager/read.mixin.vue'),
		// TABインデックス制御
		require('js/common/tabIndex.mixin.vue'),
	],
	created: function () {
		// ドラック用ダイアログID記載
		this.m_dragID = this.r_dragid;
//		this.scrollStop();
	},
	computed:{
		arr_sub_title:function(){
			if(typeof this.r_subtitle == "string"){
				return [this.r_subtitle];
			}else if(typeof this.r_subtitle == "array"){
				return this.r_subtitle;
			}
			else if(typeof this.r_subtitle == "object"){
				return this.r_subtitle;
			}
			return [];
		},
		is_smart_phone:function(){
			return this.manager.isSmartPhone();
		},
		modal_mask_content_number:function(){
			return (this.r_is_first)?"modal-mask-content-first":"modal-mask-content-second";
		},
		container_class:function(){
			if(this.r_is_first && this.is_smart_phone) {
				return '';
			}
			return "modal-container-pc";
		}
	},
	mounted: function () {
		if(this.container_class === 'modal-container-pc'){
			// const headerHeight = $('.modal-header:last')[0].offsetHeight;
			// $('.body-container:last').css('max-height', 768 - headerHeight);
			$('.body-container:last').css('height', '85vh');
		}
	},
	methods: {
		//! キャンセル
		onBtnCancel: function( event ){
			console.log("[ onBtnCancel ]");
//			this.scrollStart();
			this.$emit('event_cancel', event );
		},
		//! スクロールON
		scrollStart: function(){
			//PC用
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
			$(document).off(scroll_event);
			//SP用
			$(document).off('.noScroll');
		},
		//! スクロールOFF
		scrollStop: function(){
			//PC用
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
			$(document).on(scroll_event,function(e){e.preventDefault();});
			//SP用
			$(document).on('touchmove.noScroll', function(e) {e.preventDefault();});
		},
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/frameDialog.vue